module.exports = __webpack_public_path__ + "static/img/hover_btn_xcx.5c4fd00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hover_btn_xcx.png
// module id = HCdQ
// module chunks = 1